import { Plus, FileText, FilePlus, FileQuestion, Upload, Medal } from 'lucide-react';

/**
 * Action commands for creating new content
 * These navigate to the relevant page with an action query param
 */
export const generateActionCommands = (canAccessSection) => {
  const actions = [
    {
      id: 'action-new-program',
      type: 'action',
      label: 'Create New Program',
      description: 'Add a new martial arts program',
      icon: FileText,
      path: '/admin/website/programs?action=new',
      section: 'programs',
      keywords: ['create', 'new', 'program', 'add'],
    },
    {
      id: 'action-new-page',
      type: 'action',
      label: 'Create Custom Page',
      description: 'Create a new custom page',
      icon: FilePlus,
      path: '/admin/website/pages?action=new',
      section: 'pages',
      keywords: ['create', 'new', 'page', 'custom', 'add'],
    },
    {
      id: 'action-new-quiz',
      type: 'action',
      label: 'Create Quiz',
      description: 'Create a new quiz for students',
      icon: FileQuestion,
      path: '/admin/learning/quizzes?action=new',
      section: 'quizzes',
      keywords: ['create', 'new', 'quiz', 'test', 'add'],
    },
    {
      id: 'action-upload-media',
      type: 'action',
      label: 'Upload Media',
      description: 'Upload images to the media library',
      icon: Upload,
      path: '/admin/website/media?action=upload',
      section: 'medialibrary',
      keywords: ['upload', 'media', 'image', 'photo', 'add'],
    },
    {
      id: 'action-new-badge',
      type: 'action',
      label: 'Create Badge',
      description: 'Create a new achievement badge',
      icon: Medal,
      path: '/admin/learning/badges?action=new',
      section: 'badges',
      keywords: ['create', 'new', 'badge', 'achievement', 'add'],
    },
    {
      id: 'action-new-vocabulary',
      type: 'action',
      label: 'Add Vocabulary Term',
      description: 'Add a new Japanese vocabulary term',
      icon: Plus,
      path: '/admin/learning/vocabulary?action=new',
      section: 'vocabulary',
      keywords: ['create', 'new', 'vocabulary', 'word', 'term', 'add', 'japanese'],
    },
  ];

  // Filter by user permissions
  return actions.filter((action) => canAccessSection(action.section));
};
